import { logAnalyticsEvent } from './firebase';

type AnalyticsValue = string | number | boolean | undefined | null;

const ATTRIBUTION_KEY = 'sheetmate_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

const safeString = (value: string | null | undefined) => value || undefined;

const getSearchParams = () => {
  if (typeof window === 'undefined') {
    return new URLSearchParams();
  }

  return new URLSearchParams(window.location.search);
};

export const captureAttribution = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const params = getSearchParams();
  const hasUtm = UTM_KEYS.some((key) => params.has(key));
  const hasRef = params.has('ref');

  if (!hasUtm && !hasRef) {
    return;
  }

  const attribution = {
    utm_source: safeString(params.get('utm_source')),
    utm_medium: safeString(params.get('utm_medium')),
    utm_campaign: safeString(params.get('utm_campaign')),
    utm_content: safeString(params.get('utm_content')),
    utm_term: safeString(params.get('utm_term')),
    ref: safeString(params.get('ref')),
    landing_path: window.location.pathname,
    first_seen_at: new Date().toISOString()
  };

  window.sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
};

export const getAttributionParams = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const stored = window.sessionStorage.getItem(ATTRIBUTION_KEY);
    return stored ? JSON.parse(stored) as Record<string, AnalyticsValue> : {};
  } catch {
    return {};
  }
};

const compactParams = (params: Record<string, AnalyticsValue>) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const trackLandingEvent = (
  eventName: string,
  eventParams: Record<string, AnalyticsValue> = {}
) => {
  if (typeof window === 'undefined') {
    return;
  }

  void logAnalyticsEvent(eventName, compactParams({
    ...getAttributionParams(),
    referrer: document.referrer || undefined,
    language: navigator.language,
    path: window.location.pathname,
    ...eventParams
  }));
};

export const withStoreUtm = (placement: string) => {
  const url = new URL('https://chromewebstore.google.com/detail/sheetmate/dkfanpiecenohobfaaceodidacdonlam');
  url.searchParams.set('utm_source', 'landing');
  url.searchParams.set('utm_medium', 'cta');
  url.searchParams.set('utm_campaign', 'organic_growth');
  url.searchParams.set('utm_content', placement);
  return url.toString();
};
